import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import s from './AdditionalFees.scss';
import {TotalGroup} from '../TotalGroup/TotalGroup';
import {TotalUpdateSkeleton} from '../TotalUpdateSkeleton';

export enum AdditionalFeesDataHook {
  Root = 'AdditionalFees.Root',
  Price = 'AdditionalFees.Price',
}

export const AdditionalFees = ({shouldShowDivider}: {shouldShowDivider: boolean}) => {
  const {t} = useTranslation();
  const {cartSummary, isSummaryUpdating, changeCartLoaders} = useControllerProps().cartStore;
  const additionalFees = cartSummary.additionalFees;

  return (
    <div className={shouldShowDivider && additionalFees.length > 1 ? s.bottomDivider : undefined}>
      <TotalGroup
        dataHook={AdditionalFeesDataHook.Root}
        totals={additionalFees.map((fee) => ({
          title: fee.name,
          value:
            changeCartLoaders && isSummaryUpdating ? () => <TotalUpdateSkeleton /> : fee.price.formattedConvertedAmount,
          key: fee.code,
          additionalAttributes: {'data-wix-additional-fees-price': AdditionalFeesDataHook.Price},
        }))}
        title={t('cart.additionalFees')}
      />
    </div>
  );
};
